export function setPageMeta({ title, description, canonical, image, noindex }) {
  if (title) {
    document.title = title;

    upsertMeta("property", "og:title", title);
    upsertMeta("name", "twitter:title", title);
  }

  if (description) {
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:description", description);
    upsertMeta("name", "twitter:description", description);
  }

  if (canonical) {
    let link = document.querySelector('link[rel="canonical"]');

    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }

    link.setAttribute("href", canonical);

    upsertMeta("property", "og:url", canonical);
  }

  // Handle noindex pages (like /admin)
  if (noindex) {
    upsertMeta("name", "robots", "noindex, nofollow");
  } else {
    removeMeta("name", "robots");
  }

  const finalImage = image || "/CR_logo.webp";

  upsertMeta("property", "og:image", finalImage);
  upsertMeta("name", "twitter:image", finalImage);
  upsertMeta("name", "twitter:card", "summary_large_image");
}

function upsertMeta(attr, key, content) {
  if (!content) return;

  let tag = document.querySelector(`meta[${attr}="${key}"]`);

  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }

  tag.setAttribute("content", content);
}

function removeMeta(attr, key) {
  const tag = document.querySelector(`meta[${attr}="${key}"]`);
  if (tag) {
    tag.remove();
  }
}